import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "reactstrap";
import currencies from "../../Currency/currency.json";
import { useDispatch, useSelector } from "react-redux";
import { makePurchase } from "../../redux/thunks/postThunks";
import { updateOrder, deleteOrder } from "../../redux/thunks/orderThunks";
import { useTranslation } from "react-i18next";
import axios from "axios";

useTranslation;
const PostModal = ({ isOpen, toggle, post, mode, triggerRefresh }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.user.data);
  const paymentCards = user?.bankingInfo?.paymentCards || [];
  const depositAccounts = user?.bankingInfo?.depositAccounts || [];
  const dispatch = useDispatch();

  const [selectedCardId, setSelectedCardId] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState("");

  if (!post) return null;

  const isModify = mode === "modify";

  const handleBuy = async () => {
    const selectedCard = paymentCards.find(
      (card) => `${card.brand} **** ${card.last4}` === selectedCardId
    );
    const selectedAccount = depositAccounts.find(
      (acc) => acc.bankAccountId === selectedAccountId
    );

    if (!selectedCard || !selectedAccount) {
      alert("Please select both a payment card and deposit account.");
      return;
    }

    const parseCadAmount = (data) => {
      if (typeof data === "string") {
        const m = data.match(/CAD:\s*([0-9]+(?:\.[0-9]+)?)/i);
        return m ? parseFloat(m[1]) : 0;
      }
      if (data && typeof data === "object") {
        if (data.CAD != null) return Number(data.CAD);
        if (data.cad != null) return Number(data.cad);
      }
      return 0;
    };

    const currentCadAmount = (() => {
      if (post?.secondary_currency === "CAD") {
        return Number((post.amount * post.rate).toFixed(2));
      }
      if (post?.primary_currency === "CAD") {
        return Number(post.amount);
      }
      return 0;
    })();

    try {
      const [tradesAmtRes, txAmtRes, radesRes] = await Promise.all([
        axios.get(
          `https://miracleapi.com/trade/getAllTradesAmountByUserIdAndDate?userId=${user.id}`
        ),
        axios.get(
          `https://miracleapi.com/transaction/getAllTransactionsAmountByUserIdAndDate?userId=${user.id}`
        ),
        axios.get(
          `https://miracleapi.com/trade/getAllTradesByUserIdAndDate?userId=${user.id}`
        ),
      ]);

      const cadFromTrades = parseCadAmount(tradesAmtRes.data);
      const cadFromTxs = parseCadAmount(txAmtRes.data);

      const todayTotalCad = cadFromTrades + cadFromTxs + currentCadAmount;

      if (todayTotalCad > 3000) {
        alert(
          "Your total trading amount inlcuding live posting exceeds 3000 CAD, your live posts will be deleted"
        );
        const tradeIds = Array.isArray(radesRes.data)
          ? radesRes.data.map((trade) => trade.id)
          : [];

        for (const id of tradeIds) {
          try {
            await dispatch(deleteOrder(id)).unwrap();
            console.log(`Deleted trade with id ${id}`);
          } catch (err) {
            console.error(`Failed to delete trade ${id}:`, err);
          }
        }
      }

      const res = await axios.get(
        `https://miracleapi.com/transaction/getAllTransactionsByUserIdAndDate?userId=${user.id}`
      );
      const transactions = res.data || [];
      console.log("failed transaction count:", transactions.length);
      if (transactions.length >= 3) {
        alert("You have failed three times within 24 hours, please try later");
        return;
      }

      const purchaseData = {
        postId: post.id,
        amountBuy: (post.amount * post.rate).toFixed(2),
        rate: post.rate,
        selectedCard,
        selectedAccount,
      };

      dispatch(
        makePurchase({ purchaseData, buyerEmail: user.email, userId: user.id })
      )
        .unwrap()
        .then(() => {
          alert("Purchase successful!");
          toggle();
        })
        .catch((err) => {
          alert(err || "Purchase failed.");
        });
    } catch (error) {
      console.error(error);
      alert("Failed to fetch transactions.");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {isModify ? t("modify.post.label") : t("buy.post.label")}
      </ModalHeader>
      <ModalBody>
        <form>
          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label>{t("i.want.to.buy.label")}</label>
                <select
                  className="form-control"
                  disabled={!isModify}
                  value={post.secondary_currency}
                >
                  <option value={post.secondary_currency}>
                    {post.secondary_currency}
                  </option>
                  {isModify &&
                    currencies.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name}
                      </option>
                    ))}
                </select>
              </div>
            </Col>
            <Col xs={6}>
              <div className="form-group">
                <label>{t("i.want.to.sell.label")}</label>
                <select
                  className="form-control"
                  disabled={!isModify}
                  value={post.primary_currency}
                >
                  <option value={post.primary_currency}>
                    {post.primary_currency}
                  </option>
                  {isModify &&
                    currencies.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name}
                      </option>
                    ))}
                </select>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label>{t("buy.amount.label")}</label>
                <input
                  type="text"
                  readOnly={!isModify}
                  className="form-control"
                  value={`${(post.amount * post.rate).toFixed(2)} ${
                    post.secondary_currency
                  }`}
                />
              </div>
            </Col>
            <Col xs={6}>
              <div className="form-group">
                <label>{t("sell.amount.label")}</label>
                <input
                  type="text"
                  readOnly={!isModify}
                  className="form-control"
                  value={`${post.amount} ${post.primary_currency}`}
                />
              </div>
            </Col>
          </Row>

          <div className="form-group">
            <label>{t("payment.method.label")}</label>
            <select
              className="form-control"
              disabled={false}
              value={selectedCardId}
              onChange={(e) => setSelectedCardId(e.target.value)}
            >
              <option value="">{t("select.label")}</option>
              {paymentCards.map((card) => (
                <option
                  key={card.id}
                  value={`${card.brand} **** ${card.last4}`}
                >
                  {`${card.brand} **** ${card.last4} (exp: ${card.expMonth}/${card.expYear})`}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>{t("deposit.account.label")}</label>
            <select
              className="form-control"
              disabled={false}
              value={selectedAccountId}
              onChange={(e) => setSelectedAccountId(e.target.value)}
            >
              <option value="">{t("select.label")}</option>
              {depositAccounts.map((account) => (
                <option
                  key={account.bankAccountId}
                  value={account.bankAccountId}
                >
                  {`${account.bankName} ****${account.accountNumber?.slice(
                    -4
                  )}`}
                </option>
              ))}
            </select>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        {isModify ? (
          <div>
            <Button
              color="danger"
              onClick={() => {
                dispatch(deleteOrder(post.id)).then(() => {
                  triggerRefresh();
                  toggle();
                });
              }}
            >
              Delete
            </Button>
            {/* <Button
              color="primary"
              onClick={() => {
                dispatch(
                  updateOrder({
                    id: post.id,
                    max: formData.max,
                    rate: formData.rate,
                  })
                );
              }}
            >
              Confirm Modification
            </Button> */}
          </div>
        ) : (
          <Button color="success" onClick={handleBuy}>
            {t("confirm.purchase.label")}
          </Button>
        )}
        <Button color="secondary" onClick={toggle}>
          {t("close.label")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PostModal;
